
import React from 'react'
import styled from 'styled-components';
import Me from '../assets/Profile.jpg';
import {MdDownload} from 'react-icons/md'
import { COLOR1, COLOR2 } from '../global';
import Mitresh_Resume from '../assets/Mitresh_Prajapati_Resume.pdf';
// import BG_IMG from '../assets/bg3_texture.png';
export const About = () => {
  
  return (
    <CONTAINER id='home'>
      <BOX>
      <p>Get to Know</p>
      <h2>About Me</h2>

      <ABOUT_CONTAINER>
        <ABOUT_CONTENT>
          <h2>Hi, I'm Mitresh</h2>
          <p>I am a <span>full-stack web developer</span> specialized in <span>MERN</span> stack. Keen to create new and innovative websites by showcasing my skills. Apart from that a <span>great team player</span>, ability to work with different kinds of people. In my spare time, I like to gain skills by which I can create something productive.
         </p>


         <a  download href={Mitresh_Resume} target="_blank"  > 
         <button onClick={()=> window.open("https://drive.google.com/file/d/1gpJtTEZt4-CaMFKaZsSBAK0FyALSXiyT/view?usp=share_link")}><MdDownload/> Resume </button>
         </a>


        </ABOUT_CONTENT>

        <ABOUT_IMAGE>
          <img src={Me} alt="profile" />
        </ABOUT_IMAGE>
      </ABOUT_CONTAINER>
      </BOX>
    </CONTAINER>
  )
}

export const CONTAINER = styled.div`
 width:100%;
 display:flex;
 padding: 5rem 0;
 border: 1px solid transparent;
 overflow-x: hidden;
 /* gap: 1.5rem; */
 background-color: #ffff;
 scroll-behavior: smooth;
 scr
 &:nth-child(2n+1){
  background-color: ${COLOR2};
 }
 &:nth-child(2n){
  background-color: ${COLOR1};
 }
@media screen and (min-width: 300px) and (max-width: 767px){
 padding: 5rem 0 ;
 }
 
`
// @media screen and (min-width: 768px) and (max-width: 1024px){
//   width: 80%;
//   display:flex;
//   justify-content: center;
//   margin:auto;
// }

// @media screen and (min-width: 300px) and (max-width: 767px){
//   width: 85%;
//   display:flex;
//   padding: 3rem 1rem;
//   justify-content: center;
//   margin:auto;
// }
export const BOX= styled.div`
 
 width: 60%;
//  min-height: 70vh;
 margin : auto;
 z-index: 2;
 border: 0.5px solid transparent;
 border-radius: 1rem;
 padding: 2rem 2rem 4rem 2rem;
 box-shadow: #1E2D2F 0px 0.25px 10px;
// box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;

 text-align:center;
 justify-content: center;
 flex-direction: column;
 background-color:white;
 p{
  font-size: 14px;
  color: grey;
  font-weight: bold;
  
 }
 h2{
  margin: -0.5rem 0 3rem 0;
  font-size: 1.7rem;
  font-weight:500;
  color: ${COLOR1};
 }
 @media screen and (min-width: 768px) and (max-width: 1024px){
  width: 80%;
  display:flex;
  justify-content: center;
  margin:auto;
}

@media screen and (min-width: 300px) and (max-width: 767px){
  width: 85%;
  display:flex;
  padding: 3rem 1rem;
  justify-content: center;
  margin:auto;
}
`
const ABOUT_CONTAINER = styled.div`
 display:flex;
 width: 100%;
 border: 1px solid transparent;
 justify-content: center;
 @media screen and (min-width: 768px) and (max-width: 1024px){
  gap: 1rem;
}

@media screen and (min-width: 300px) and (max-width: 767px){
  flex-direction: column-reverse;
  gap: 1rem;
}
 
`
const ABOUT_CONTENT = styled.div`
 width:75%;
 text-align:left;
 margin: auto;
 h2,p,button{
  margin: auto 3rem;
 }
 span{
  font-size: 16px;
  color:black;
  font-weight: bold;
 }
 button{
  padding: 1rem 1.6rem;
  border: 1.5px solid transparent;
  border-radius: 0.5rem;
  background-color: ${COLOR1};
  color: white;
  margin-top: 1rem;
  font-size: 1rem;
  font-weight: bold;
  &:hover{
    color:${COLOR1};
    background-color: ${COLOR2};
    border: 1.5px solid ${COLOR1};
  }
 }

 
 
 @media screen and (min-width: 300px) and (max-width: 767px){
  width: 100%;
  margin-top: 3rem;
  h2,p,button{
    margin: auto;
   }
   button{
    margin-top: 2rem;
   }
 }
`
const ABOUT_IMAGE = styled.div`
 display:flex;
 border: 1px solid transparent;
 justify-content: center;
 width: 15rem;
 height: 15rem;
 margin: auto;
 img{
  border-radius: 50% ;
  border: 1px solid transparent;
  margin:auto;
  width:100%;
  height:100%;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
 
}

  
 

`